export class TranslationFr {

  static readonly dict =
    {
      'advise.info.not_supported_audio': 'Votre navigateur ne supporte pas l\'élément <code>audio</code>',
      'assignment_method': 'Assignation',
      'assignment_method.competitive': 'Compétitive',
      'assignment_method.manual': 'Manuel',
      'assignment_method.prequalification': 'Préqualification concurrentielle',
      'assignment.rules.table.row.everything': 'Tous',
      'assignment.rules.table.row.everything_2': 'Toute',
      'auth.labels.logout': 'Se déconnecter',
      'auth.profile': 'Mon profil',
      'brand.leads.chart.no_brand': 'Sans marque',
      'calendar.add_event': 'Ajouter événement',
      'calendar.confirm_visit': 'Rapport de visite',
      'calendar.scheduler': 'Programmer',
      'call.has.another.started.call': 'Vouz aves un autre appel en cours',
      'call.started.call': 'Appel en cours:',
      'call.view.lead': 'Voir le lead',
      'call.view.lead_with_link': 'Vous avez un autre lead en interaction. Voir lead',
      'channel.to.day.week.leads.chart.bar': 'Barres',
      'channel.to.day.week.leads.chart.day.name': 'Jour de la semaine',
      'channel.to.day.week.leads.chart.day.name.friday': 'Vendredi',
      'channel.to.day.week.leads.chart.day.name.monday': 'Lundi',
      'channel.to.day.week.leads.chart.day.name.saturday': 'Samedi',
      'channel.to.day.week.leads.chart.day.name.sunday': 'Dimanche',
      'channel.to.day.week.leads.chart.day.name.thursday': 'Jeudi',
      'channel.to.day.week.leads.chart.day.name.tuesday': 'Mardi',
      'channel.to.day.week.leads.chart.day.name.wednesday': 'Mercredi',
      'channel.to.day.week.leads.chart.leads.count': 'Nombre de leads',
      'channel.to.day.week.leads.chart.line': 'Lignes',
      'channel.to.day.week.leads.chart.stack': 'Empiler',
      'channel.to.day.week.leads.chart.tiled': 'Regrouper',
      'channel.to.day.week.leads.chart.undefined': 'Pas spécifié',
      'channel.to.hour.leads.chart.day.hour': 'Heure du jour',
      'channel.to.hour.leads.chart.leads.count': 'Nombre de leads',
      'channel.to.hour.leads.chart.stack': 'Empiler',
      'channel.to.hour.leads.chart.tiled': 'Regrouper',
      'channel.to.hour.leads.chart.undefined': 'Pas spécifié',
      'chat.show_hidden': 'Montrer/Cacher le chat',
      'chat.support': 'Support',
      'concurrence.time.0': 'Jour actuel',
      'concurrence.time.1': '1 jour',
      'concurrence.time.7': '7 jours',
      'concurrence.time.15': '15 jours',
      'concurrence.time.30': '1 mois',
      'concurrence.time.60': '2 mois',
      'concurrence.time.90': '3 mois',
      'concurrence.time.120': '4 mois',
      'concurrence.time.150': '5 mois',
      'concurrence.time.180': '6 mois',
      'concurrence.time.365': '1 an',
      'concurrence.time.9999': 'Pas de limite de temps',
      'concurrence.time.-1': 'Désactivé',
      'dealer.leads.chart.no_dealer': 'Sans concession',
      'drag-and-drop.item-selected-title': 'Éléments sélectionnés',
      'drag-and-drop.item-unselected-title': 'Éléments à sélectionner',
      'dropdown.notificationDeliveryMethod.both': 'Email et push',
      'dropdown.notificationDeliveryMethod.email': 'E-mail',
      'dropdown.notificationDeliveryMethod.not_notification': 'Ne pas notifier',
      'dropdown.notificationDeliveryMethod.push': 'Push',
      'dropdown.unknown': 'Pas spécifié',
      'dropdown-with-rule.true': 'Activé',
      'dropdown-with-rule.false': 'Désactivée',
      'error.data_wrong_funnel': 'Les données ne sont pas cohérents avec la procédure de qualification',
      'error.duplicated_session.body': 'Session ouverte dans un autre dispositif',
      'error.duplicated_session.title': 'Session double',
      'error.email_is_not_valid': 'L’adresse e-mail n’est pas valide',
      'error.vat_is_not_valid': 'Le NIF/SIRET n’est pas valide.',
      'error.found.external_system': 'Lead déjà envoyé au système externe',
      'error.lead_allready_assigned': 'Lead déjà assigné',
      'error.lead_assigned_another_user': 'Le lead est assigné à un autre utilisateur',
      'error.lead_closed': 'Le lead est finalisé',
      'error.lead_in_call': 'Lead en appel',
      'error.lead_must_be_archived_or_on_track': 'Le lead doit être classé ou suivi',
      'error.lead_must_be_new_or_on_track': 'L’état de ce lead doit être nouveau ou suivi',
      'error.lead_not_status_new': 'L\'état de ce lead n\'est pas nouveau',
      'error.not_found.company': 'Entreprisse pas trouvé',
      'error.not_found.external_system': 'Système externe pas trouvé',
      'error.not_found.lead': 'Lead pas trouvé',
      'error.not_reopen_because_already_open.lead': 'Le lead est déjà suivi',
      'error.operation_not_allowed': 'Opération interdite',
      'error.security_control.body': 'Demande pas acepté. Vous devez vous connecter à nouveau',
      'error.security_control.title': 'Contrôle de sécurité',
      'error.session_expired.body': 'Votre session à expirée, connectez-vous à nouveau',
      'error.session_expired.title': 'Session expiré',
      'error.thrift_response.integration': 'Erreur d’intégration du lead avec le système externe',
      'error.user_config_updated.body': 'Votre utilisateur a été actualité. Vous avez besoin de vous connecter à nouveau',
      'error.user_config_updated.title': 'Utilisateur actualisé',
      'error.user_has_been_disabled.body': 'L’utilisateur avec lequel vous tentez vous connecter est désactivé',
      'error.user_has_been_disabled.title': 'Utilisateur désactivé',
      'error.user_in_call': 'Utilisateur en appel',
      'error.validations.date_should_be_major_that_actual': 'La date indiquée doit être majeure à la date actuelle',
      'error.validations.this_field_is_required': 'Ce champs est obligatoire',
      'errors.event_no_added': 'Événement pas ajouté',
      'errors.event_should_date_greater_that_current': 'L’événement doit avoir une date majeure à la date actuelle',
      'error.validations.already_in_the_list': 'Déjà dans la liste',
      'error.validations.cannot_be_empty': 'Ce champ ne peut pas être vide',
      'filters.company': 'Entreprisse',
      'filters.contact.filter_by_email': 'Adresse e-mail',
      'filters.contact.filter_by_name': 'Nom',
      'filters.contact.filter_by_phone': 'Téléphone',
      'filters.contact.undefined': 'Nom / Adresse e-mail/ Téléphone',
      'filters.error.three_chars_needed.filter_by_email': '* Il doit avoir au moins 3 caractères',
      'filters.error.three_chars_needed.filter_by_name': '* Il doit avoir au moins 3 caractères',
      'filters.error.three_chars_needed.filter_by_phone': '* Il doit avoir au moins 3 chiffres',
      'filters.error.three_chars_needed.filter_by_postal_code': '* Il doit avoir au moins 3 caractères',
      'filters.error.three_chars_needed.filter_by_province_and_location': '* Il doit avoir au moins 3 caractères',
      'filters.error.three_chars_needed.undefined': '* Il doit avoir au moins 3 caractères',
      'filters.has_appointment_filter_token': 'Leads avec rendez-vous',
      'filters.have_filter_selected': 'Il y a d’autres filtres marqués',
      'filters.in_call': 'En appel',
      'filters.in_prequalification': 'En pré-qualification',
      'filters.no_report': 'Pas de rapport (Rendez-vous)',
      'filters.not_come': 'Pas d’assistance (Rendez-vous)',
      'filters.postal_code.filter_by_postal_code': 'Code postal',
      'filters.postal_code.filter_by_province_and_location': 'Région / Ville',
      'filters.postal_code.undefined': 'Code postal / Région / Ville',
      'filters.select_range_of_dates': 'Sélectionner la date',
      'filters.title': 'Filtres',
      'filters.transferred_not_received': 'Transfert pas reçu',
      'filters.yes_come': 'Assistance (Visite)',
      'funnel.closed.leads': 'Ventes finalisée',
      'funnel.contacted.leads': 'Contactés',
      'funnel.total.leads': 'Leads reçus',
      'funnel.total_appointments': 'Rendez-vous',
      'funnel.visited.leads': 'Visites',
      'header.new_lead.title': 'Nouveau lead',
      'header.no_selected_company': 'Aucune entreprisse sélectionné',
      'header.select_company': 'Sélectionner entreprisse',
      'help.active_business_hours': 'Activer ou désactiver l’horaire de travail dans le calendrier d’événements',
      'help.assignment_rules.simulator': 'Remplissez les champs avec les informations d\'un test lead et cliquez sur "Simuler". Les utilisateurs, autres que Superadmin, qui pourraient voir ladite piste seront indiqués.',
      'help.active_business_hours_company': 'Configuration de l’horaire de travail de l’entreprisse: ' + '<ul>' + '<li> Cet horaire sera pris en compte pour le calcul du temps de réponse des utilisateurs,' + 'en mesurant le temps écoulé entre l’entrée du lead et la première tentative de contact.</li>' + '<li> Le temps commencera à compter à partir du moment où vous vous trouvez dans un horaire défini jusqu’à l’heure de la première tentative de contact.</li>' + '<li> L’heure de début doit toujours être inférieure à l’heure de fin',
      'help.assignment_rules_configuration': 'Règles d\'affectation',
      'help.lead_table_visibility_company': 'Configuration des champs visibles dans le tableau des leads:' + '<ul>' + '<li>Vous pouvez activer ou désactiver les champs que vous voulez' + 'que les utilisateurs Vendeurs, qui n\'ont pas les leads affectés.</li>' + '<li>N\'oubliez pas que le terme "Caché" signifie que vous ne pouvez pas voir ce champ dans le tableau des leads.</li>' + '</ul>',
      'help.add_day_week': 'Ajoutez un jour de travail de la semaine à votre horaire',
      'help.business_hours_user': 'Configuration de l’horaire du travail de l’utilisateur: ' + '<ul>' + '<li> Cet horaire sera pris en compte pour mettre en évidence les heures de travail de chaque utilisateur dans les calendriers d’attribution des rappels et/ou des rendez-vous.</li>' + '<li> L’heure de début doit toujours être inférieure à l’heure de fin.</li>' + '</ul>',
      'help.change_password_required': 'Changement du mot de pase.<br>' + '<ul>' + '<li>Il doit avoir au moins un chiffre</li>' + '<li>Il doit avoir au moins une majuscule</li>' + '<li> Il doit avoir au mins un caractère spécial</li>' + '<li> Il doit avoir plus de 4 caractères</li>' + '</ul>',
      'help.concurrence': 'Configuration du temps de coïncidence du lead pour l’entreprisse: ' + '<ul>' + '<li>Le calcul pour la vérification de la concordance sera effectué avec la date de création du lead.</li>' + '<li>L’intervalle de temps sera calculé en appliquant ± le temps configuré à la date de création du lead.</li>' + '<li>Les mois sont considérés comme 30 jours naturels.</li>' + '<li>L’année est considérée comme 365 jours naturels.</li>' + '<li>Exemple: [ (-x jours).....(Date de création).....(+x jours) ]</li>' + '</ul>',
      'help.configure_assignment_method': 'Méthode d’assignation des leads: <br> <ul>' + '<li>Manuel' + '<ul>' + '<li>Seuls les utilisateurs ayant le rôle d’administrateur et de BDC seront informés de l’entrée des nouveaux leads,' + 'étant ceux qui sont chargés de la distribution/qualification du lead.</li>' + '<li> Les utilisateurs ayant un rôle de conseiller commercial n’auront à leur disposition que les leads qui leur sont attribuées.</li>' + '</ul></li> ' + '<li>Compétitive' + '<ul>' + '<li>Les règles d’affectation définies pour les utilisateurs ayant un rôle de conseiller commercial et ' + 'BDC entreront en jeu pour notifier l’entrée de nouveaux leads aux utilisateurs qui respectent les règles avec le lead reçu.</li>' + '<li>Si aucun utilisateur n’est pas soumis à cette règle, les utilisateurs ayant le rôle d’administrateur seront avertis.</li>' + '<li>Les utilisateurs ayant un rôle de conseiller commercial auront à leur disposition les leads qui sont attribuées à leur utilisateur et, ' + 'en outre, les leads qui respectent leurs règles d’attribution et qui ne sont pas attribuées.</li>' + '<li>Les utilisateurs ayant un rôle de BDC auront à leur disposition les leads qui sont assignées à leur utilisateur ' + ' ainsi que les leads qui respectent leurs règles d’assignation, quel que soit l’utilisateur auquel ils sont assignées ou non.</li></ul>' + '<li>Préqualification concurrentielle:' + '<ul>' + '<li> Les leads entrant dans DMSVO seront visibles pour les utilisateurs Admin, Superadmin et BDC. </li>' + '<li>Leur arrivée sera notifiée à l\'utilisateur BDC. </li>' + '<li> Le statut initial de ces leads sera "Pré-qualification". </li>' + '<li>Les utilisateurs Vendeur n\'auront pas de leads en "Pré-qualification" dans leur liste. S\'ils y accèdent par la recherche avancée, ils ne pourront pas voir leurs informations, car leur accès sera bloqué.</li>' + '<li>Lorsque l\'utilisateur BDC/Admin ou Superadmin gère le lead, il aura deux options : l\'attribuer à un autre utilisateur ou le laisser non attribué. Ces leads passeront au statut de "Nouveau".</li>' + '<li>Dans le cas où le lead n\'est pas assignée, le système compétitif démarre, notifiant les utilisateurs selon les règles d\'assignation. </li>' + '</ul></li> ' + '</ul>',
      'help.configure_time_business_hours': 'Configurez l’horaire pour le jour indiqué',
      'help.configure_timezone': 'Fuseau horaire de l’entreprise, qui influencera l’affichage des données de type date/heure de l’entreprise, ' + 'étant donné que cette configuration s’applique à tous les utilisateurs travaillant dans l’entreprise',
      'help.tab_change_password': 'Changer le mot de passe',
      'help.tab_configure_company': 'Configuration de l’entreprisse',
      'help.tab_user_settings': 'Configuration de l’utilisateur',
      'help.tracking_email': 'Configuration du suivi des emails pour l\'entreprise:<br><ul><li> Les avantages dont vous bénéficiez:<ul><li>'
        + 'Traçabilité de toutes les communications par email avec le lead. </li> <li> Enregistrement des réponses du lead dans le résumé.</li></ul>'
        + '</li><li>Comment cela fonctionne:<ul><li>DMSVO génère automatiquement un compte email pour chaque utilisateur.</li><li>'
        + 'La réponse à un email est enregistrée dans le résumé du lead. </li><li>L\'utilisateur est informé en temps réel de l\'arrivée d\'une réponse'
        + 'd\'un lead.</li></ul></li></ul>',
      'help.user_account': 'Compte d\'utilisateur : <br> <ul> <li> Accès à DMSVO. </li> <li> Réception des notifications par e-mail. </li> </ul>',
      'help.user_name_surname': 'Nom et prénom : <br> <ul> <li> Veuillez indiquer le nom et prénom de l\'utilisateur pour montrer dans les sélecteurs. </li>'
        + '<li>Le nom et prénom sont ajoutés pour l\'enovoie des e-mails à partir du fichier des leads.</li> </ul>',
      'help.user_phone_number': 'Teléfono: <br> <ul> <li> Enregistre le numéro de téléphone de l\'utilisateur à titre informatif. </li>',
      'help.user_language': 'Langue : <br> <ul> <li> Langue de la plateforme pour l\'utilisateur. </li> </ul>',
      'help.user_notifications': 'Notifications : <ul> <li> Système de notification qui permet à l\'utilisateur d\'être informé de tous les événements qui se produisent, tels que : nouveaux leads, mise à jour d\'un lead, rappels de suivi, etc.</li>'
        + '<li> Push : Méthode de notification directe envoyée au dispositif de l\'utilisateur où la session est active.</li>'
        + '<li> E-mail : Méthode de notification par e-mail au compte de l\'utilisateur. </li> </ul>',
      'help.user_sending_email': 'E-mail d\'envoie : <ul> <li> Adresse e-mail pour l\'envoi d\'e-mails aux leads. </li>'
        + '<li>Adresse e-mail à laquelle les leads peuvent répondre aux e-mails </li>'
        + '<li>Si la licence a le "Suivi des e-mails" actif, les réponses aux e-mails envoyés seront enregistrées dans les résumés des leads correspondants. </li>'
        + '<li>Si le compte d\'email est "no-reply", cela signifie que la licence n\'a pas le "Suive des e-mails actif"</li> </ul>',
      'help.assignment-rules.step-1': 'Bienvenue dans l\'assistant de création de règles de répartition' +
        '<p>Avec ce système, vous pourrez définir les leads qui seront visibles pour chacun des utilisateurs de l\'outil. </p>' +
        '<p>Étape 1 :</p><ul><ul><li>Identifier cette règle avec un nom, par exemple : "utilisateur - Concessions VO</li>' +
        '<li>Choisir l\'utilisateur pour lui définir la règle.</li>' +
        '<li>Si l\'utilisateur doit avoir accès à tous les leads qui entrent dans l\'outil, cliquez sur "Je veux qu\'il voie tout".' +
        ' Sinon, commencez votre configuration à "Je veux lui configurer la règle.</li></ul>',
      'help.assignment-rules.step-2': ' Étape 2 :<ul><li>Sélectionnez un ou plusieurs types de leads à montrer à l\'utilisateur sélectionné.</li></ul>',
      'help.assignment-rules.step-3': ' Étape 3 :<ul><li>Sélectionnez une ou plusieurs concessions à partir desquelles l\'utilisateur sélectionné pourra visualiser les leads.</li></ul>',
      'help.assignment-rules.step-4': ' Étape 4 :<ul><li>Sélectionnez un ou plusieurs canaux à partir desquels l\'utilisateur sélectionné pourra consulter les leads.</li></ul>',
      'help.assignment-rules.step-5': '  Étape 5 :<ul><li>Sélectionnez une ou plusieurs marques à partir desquelles l\'utilisateur sélectionné pourra consulter les leads.</li>',
      'help.assignment-rules.step-6': ' Étape 6 :<ul><li>Tapez le ou les codes postaux pour lesquels l\'utilisateur sélectionné pourra voir les leads.</li></ul>' +
        '<li>N\'oubliez pas de cliquer sur "Ajouter" pour les ajouter à la liste.</li></ul>',
      'help.assignment-rules.step-7': ' Étape 7 :<ul><li>Tapez un ou plusieurs champs d’origine à partir desquels l\'utilisateur sélectionné pourra visualiser les leads.</li>' +
        '<li>N\'oubliez pas de cliquer sur "Ajouter" pour les ajouter à la liste.</li>' + '<li>N\'oubliez pas que l\'origine sélectionnée ici doit être exactement la même que celle définie par le lead.</li></ul>',
      'help.assignment-rules.step-8': ' Étape 8 :<ul><li>Au moment de "Terminer", la règle sera active en appliquant tous les paramètres sélectionnés.</li>' + '<li>Au cas où elle ne devrait pas être activée à ce moment, cliquez sur "Désactivé"; et, si tout ce qui est configuré est ce que l\'utilisateur ne devrait PAS voir, sélectionnez "Règle négative".</li></ul>',
      'help.dropdown-with-rules': 'Lors de la création ou de la modification d\'un lead, seuls les utilisateurs ayant le rôle Business Advisor obtiendront les valeurs dans les listes déroulantes qui répondent aux conditions de leurs règles d\'attribution définies.',
      'info.coming_soon': 'Biêntot',
      'info.new_content': 'Nouveau!',
      'lead_archived_type.contacteds': 'Contactés',
      'lead_archived_type.not_contacted': 'Pas contacté',
      'lead_archived_type.not_contacteds': 'Pas contactés',
      'lead_archived_type.not_interested': 'Pas intéressés',
      'lead_archived_type.other': 'Autres',
      'lead_archived_type.by_price': 'Par prix',
      'lead_archived_type.by_appraisal': 'Par évaluation',
      'lead_archived_type.by_financing': 'Par financement',
      'lead_archived_type.immature': 'Lead pas consolidé',
      'lead_archived_type.samebrand': 'Même marque',
      'lead_archived_type.anotherbrand': 'Autre marque',
      'lead_archived_type.samebrand_dealership': 'Même marque (autre concessionnaire)',
      'lead_archived_type.anotherbrand_dealership': 'Autre marque (autre concessionnaire)',
      'leadType.': 'Autres',
      'leadType.after_sale': 'Après-vente',
      'leadType.commercial': 'Véhicule commercial',
      'leadType.fleet': 'Flottes',
      'leadType.new_vehicle': 'Véhicule nouveau',
      'leadType.used_vehicle': 'Véhicule d’occasion',
      'leadType.renting': 'Renting',
      'chart.lead_type.': 'Autres',
      'chart.lead_type.after_sale': 'Après-vente',
      'chart.lead_type.commercial': 'Véhicule commercial',
      'chart.lead_type.fleet': 'Flottes',
      'chart.lead_type.new_vehicle': 'Véhicule nouveau',
      'chart.lead_type.used_vehicle': 'Véhicule d’occasion',
      'chart.lead_type.renting': 'Renting',
      'chart.lead_type.rent_a_car': 'Rent a Car',
      'legend.filter.archived_leads': 'Leads classé',
      'legend.filter.contact': 'Contacte',
      'legend.filter.comments': 'Commentaires',
      'legend.filter.last_lead_modification': 'Dernier modification du lead',
      'legend.filter.lead_creation': 'Création du lead',
      'legend.filter.lead_date_of': 'Date de ',
      'legend.filter.lead_information': 'Informations du lead',
      'legend.filter.on_track_lead': 'Lead suivi',
      'legend.filter.reminder': 'Rappel',
      'legend.filter.sold_leads': 'Lead expiré',
      'legend.filter.tracings': 'Suivis',
      'legend.filter.visit_appointment': 'Rendez-vous/Visite',
      'legend.filter.last_modification': 'Dernière modification',
      'menu.admin': 'Administration',
      'menu.configuration': 'Configuration',
      'menu.home': 'Accueil',
      'menu.dashboard': 'Tableau de bord',
      'menu.leads.title': 'Leads',
      'menu.lead_table_visibility': 'Tableau des leads',
      'menu.login.change.password.title': 'Changer le ot de passe',
      'menu.login.logout.title': 'Se déconnecter',
      'menu.login.title': 'Accès',
      'menu.metrics.marketing.title': 'Marketing',
      'menu.metrics.sales.title': 'Ventes',
      'menu.metrics.title': 'Métriques',
      'menu.analytics.title': 'Analyse',
      'menu.planning_of_day.title': 'Planification',
      'menu.quotations.title': 'Devis',
      'menu.reporting.title': 'Reporting',
      'menu.working_hours': 'Horaire de travail',
      'metric_lead.appointment_scheduled.title': 'Nº de rendez-vous programmés',
      'metric_lead.assigned_date.title': 'Dermièr transfert',
      'metric_lead.call_start_time.title': 'Début de l’appel actuel',
      'metric_lead.created_at.title': 'Entrée de leads',
      'metric_lead.emails_received.title': 'Nº d’e-mail reçus',
      'metric_lead.emails_sent.title': 'Nº d’e-mail envoyés',
      'metric_lead.end_defeat_date.title': 'Prochaine échéance',
      'metric_lead.first_assigned_date.title': 'Première assignation',
      'metric_lead.first_call_date.title': 'Première appel répondu',
      'metric_lead.first_contact_bussiness.title': 'Temps de réponse (horaire commercial)',
      'metric_lead.first_contact_date.title': 'Premier contact',
      'metric_lead.first_contact_user.name': 'Utilisateur qui a réalisé le premier contact',
      'metric_lead.first_interaction_date.title': 'Première interaction',
      'metric_lead.first_user_assigned.title': 'Premier utilisateur assigné',
      'metric_lead.real_response_time.title': 'Temps de réponse (réel)',
      'metric_lead.reminders_scheduled.title': 'Nº de rappels programmés',
      'metric_lead.times_edited.title': 'Nº de fois édité',
      'metric_lead.times_transferred.title': 'Nº de fois transfert',
      'metric_lead.times_with_call_response.title': 'Nº d’appels répondus',
      'metric_lead.times_without_call_response.title': 'Nº d’appels sans réponse',
      'metric_lead.total_interactions.title': 'Total d’interactions',
      'metric_lead.transferred.title': 'En attente de transfert',
      'metric_lead.updated_at.title': 'Dernier modification',
      'metric_lead.whatsapps_sent.title': 'Nº de WhatsApp envoyés',
      'metrics.marketing.channel.leads.table.channel.undefined': 'Pas spécifié',
      'metrics.marketing.channel.leads.table.head.channel': 'Canal',
      'metrics.marketing.channel.leads.table.head.closed': 'Ventes',
      'metrics.marketing.channel.leads.table.head.contacted': 'Contactés',
      'metrics.marketing.channel.leads.table.head.leads': 'Leads',
      'metrics.marketing.channel.leads.table.head.onTrack': 'Suivis',
      'metrics.marketing.channel.leads.table.head.total': 'TOTAL',
      'metrics.marketing.channel.leads.table.head.totalAppointments': 'Rendez-vous',
      'metrics.marketing.channel.leads.table.head.visited': 'Visites',
      'modal.body.date.notification_received': 'Notification reçue le:',
      'modal.response.add.receiver.lead': 'Ajouter comme destinataire "Cc"',
      'modal.response.notification.lead': 'Répondre avec la notification qui a géré le lead',
      'modal.response.notification.lead_generated': 'La notification par mail qui a généré ce lead dans DMSVO sera ajoutée à la fin du courriel',
      'modal.subject.response': 'RE:',
      'modals.appointment.choose_when': 'Date du rendez-vous :',
      'modals.appointment.this_lead_already_has_a_appointment': 'Ce lead a déjà une rendez-vous programmé',
      'modals.appointment.title': 'Rendez-vous',
      'modals.archive.archived_option.required': 'Sélectionner une option',
      'modals.archive.comments.required': 'Commentaire obligatoire',
      'modals.archived_lead.title': 'Classer lead',
      'modals.are.you.sure.delete.this.lead': 'Êtes-vous sûr de vouloir supprimer le lead?',
      'modals.assign.button': 'Assigner',
      'modals.assign.leads.title': 'Assigner leads',
      'modals.calendar.transfer_to_another_user': 'Le lead va être transféré à un utilisateur différent de l\'utilisateur actuel, êtes-vous sûr?',
      'modals.call.finish_call_form.comments.required': 'Commentaire obligatoire',
      'modals.call.finish_call_form.on_track_status.required': 'Sélectionnez une option',
      'modals.call.title': 'Résultat de l’intégration',
      'modals.call.visit_confirmation_form.attended': 'Présent',
      'modals.call.visit_confirmation_form.date_result': 'Résultat du rendez-vous',
      'modals.call.visit_confirmation_form.not_attended': 'Absent',
      'modals.cancel.button': 'Annuler',
      'modals.close.button': 'Fermer',
      'modals.close.choose_when': 'Date de la vente',
      'modals.close.comments.required': 'Commentaire obligatoire',
      'modals.close.select_date': 'Sélectionner une date:',
      'modals.close_sale.title': 'Fermer la vente',
      'modals.comment.add_comment': 'Ajouter un commentaire',
      'modals.complete_name': 'Nom et prénom',
      'modals.delete.button': 'Supprimer',
      'modals.delete.comments.required': 'Commentaire obligatoire',
      'modals.delete.leads.title': 'Êtes-vous sûr?',
      'modals.edit.lead.title': 'Modifier lead',
      'modals.import.title': 'Importer des leads à partir d’un fichier .csv',
      'modals.importer.brand_not_found': 'La marque n’a pas été trouvée',
      'modals.importer.button': 'Importer',
      'modals.importer.channel_not_found': 'Le canal n’a pas été trouvé',
      'modals.importer.check_fields': 'Validation des champs',
      'modals.importer.columns_is_not_correct': 'Ne contient pas les bonnes colonnes',
      'modals.importer.creating_new_leads': 'Création des nouveaux leads',
      'modals.importer.dealer_not_found': 'Le concession n\'a pas été trouvée',
      'modals.importer.email_phone_is_required': 'Adresse e-mail / Téléphone obligatoire',
      'modals.importer.comment_max_size': 'Le commentaire ne peut pas avoir plus de 1000 caractères',
      'modals.importer.status_is_required': 'L\'état obligatoire',
      'modals.importer.file': 'Fichier',
      'modals.importer.headers.file_line': 'Ligne du fichier',
      'modals.importer.headers.message': 'Message',
      'modals.importer.headers.name': 'Nom',
      'modals.importer.headers.number_lead': 'Lead Nº',
      'modals.importer.instructions.codification': 'Le cryptage UTF-8',
      'modals.importer.instructions.delimiter_quotes': 'Délimiteur de texte entre guillemets "',
      'modals.importer.instructions.format_should_csv': 'Format .csv',
      'modals.importer.instructions.header': 'Importer le fichier (csv)',
      'modals.importer.instructions.headers_valids': 'La première ligne d’intitulés ne sera pas prise en compte,' + 'mais ils doivent respecter l’ordre des colonnes. Vous pouvez télécharger un modèle',
      'modals.importer.instructions.headers_valids_here': 'ici',
      'modals.importer.instructions.info_channel': 'Les informations sur le canal / la marque / le type / l’établissement/ température/ Raison d\'archivage doivent être identiques' + 'à celles affichées dans les menus déroulants de la section des filtres',
      'modals.importer.instructions.postal_code': 'Les informations du code postal (CP) ne doivent être que les chiffres du code',
      'modals.importer.instructions.dates': 'Formats pris en charge pour les dates: 21/6/2021 15:13:21, 21/06/2021 15:13:21, 21/6/2021 ó 21/06/2021',
      'modals.importer.instructions.separator_fields': 'Séparateur de champ point-virgule ";"',
      'modals.importer.instructions.id': 'L\'information sur l\'ID est obligatoire et doit être unique pour chaque ligne.',
      'modals.importer.instructions.status': 'Champs obligatoires :',
      'modals.importer.instructions.statusv2': 'État. Selon la valeur indiquée, il sera également obligatoire :',
      'modals.importer.instructions.name': 'Nom et prénom.',
      'modals.importer.instructions.email': 'Téléphone ou e-mail.',
      'modals.importer.instructions.new_lead': 'Valeur "Nouveau Lead" : aucun champ supplémentaire obligatoire.',
      'modals.importer.instructions.new_lead_info': 'Tous les autres champs consécutifs par ligne ne sont pas obligatoires.',
      'modals.importer.instructions.on_track': 'Valeur "En suivi" : "Date de création", "Date de suivi" et "Température" obligatoires.',
      'modals.importer.instructions.on_track_info': 'Champs obligatoires "Date de création" et "Date de suivi".',
      'modals.importer.instructions.close': 'Valeur "Vente fermée" : "Date de création", "Date de suivi", "Date de vente fermée" et "Température" obligatoires.',
      'modals.importer.instructions.close_info': 'Champs obligatoires "Date de création" et "Date de clôture de la vente".',
      'modals.importer.instructions.archive': 'Valeur "Archivé" : "Date de création", "Date d\'archivage" et "Raison d\'archivage" obligatoires.',
      'modals.importer.instructions.archive_info': 'Champs obligatoires "Date de création" et "Date de clôture de la vente".',
      'modals.importer.instructions.plate': 'Formats acceptés pour l\'immatriculation: "1111XXX, X1111X, XX111111, XX1111XX, 1XXXX11, X1111XXX".',
      'modals.importer.instructions.vat': 'Formatos acceptés pour NIF/SIRET: Espagne',
      'modals.importer.instructions.user': 'Utilisateur : sauf pour le statut "Nouveau Lead".',
      'modals.importer.name_is_a_required_field': 'Nom et prénom obligatoires',
      'modals.importer.status_invalid_option': 'modals.importer.status_invalid_option',
      'modals.importer.id_is_required': 'modals.importer.id_is_required',
      'modals.importer.name_is_required': 'Nombre y apellidos son campos requeridos',
      'modals.importer.id_is_duplicated': 'ID ne peut pas être répété',
      'modals.importer.invalid_plate': 'Le format d\'enregistrement n\'est pas correct',
      'modals.importer.invalid_vat': 'Valeur non valide',
      'modals.importer.phone_invalid': 'Téléphone invalide',
      'modals.importer.date_less_now': 'Le champ Date ne peut pas être supérieur à la date actuelle',
      'modals.importer.date_less_created': 'Le champ Date ne peut pas être inférieur à la date de création',
      'modals.importer.date_less_ontrack': 'Le champ Date ne peut pas être inférieur à la date de suivi',
      'modals.importer.preparing_new_leads': 'Préparation des leads',
      'modals.importer.validating_users': 'Validation des utilisateurs',
      'modals.importer.validating_ids': 'Validation des Ids',
      'modals.importer.validating_brands': 'Validation des marques',
      'modals.importer.validating_channels': 'Validation des canaux',
      'modals.importer.validating_dealers': 'Validation des concessions',
      'modals.importer.validating_headers': 'Validation des intitulés',
      'modals.importer.validating_lead_columns': 'Validation des colonnes',
      'modals.importer.validating_types': 'Validation des types',
      'modals.leadin_live.copied_link': 'Copier le lien',
      'modals.leadin_live.copied_message': 'Copié!',
      'modals.leadin_live.copy_button': 'Copier',
      'modals.leadin_live.expiration_advice': 'Veuillez noter que le lien expirera au bout d\'une heure',
      'modals.leadin_live.header': 'DMSVO Live',
      'modals.leadin_live.leadin_live_info': '<p>Vous n\'avez pas encore activé<b>DMSVO Live</b>? Contactez avec notre équipe pour activer cette nouvelle fonctionnalité.</p>' + '<p><b>DMSVO Live</b> est un système d\'appel vidéo entièrement intégré dans DMSVO.</p>' + '<p>Avec <b>DMSVO Live</b> vous pourrez faire des visites par appel vidéo pour montrer les véhicules que vos leads recherchent. En outre, vous pouvez partager l\'écran de votre ordinateur pour leur montrer tout ce dont vous avez besoin pour vous aider dans la vente.</p>',
      'modals.leadin_live.request_subscription': 'Demande d\'enregistrement',
      'modals.leadin_live.room_access': 'Accéder à la salle DMSVO Live',
      'modals.leadin_live.select_channel': 'Sélectionnez le canal par lequel vous souhaitez envoyer au client le lien pour commencer l\'appel vidéo',
      'modals.leadin_live.select_channel_to_invite_one': 'Sélectionnez le canal par lequel vous souhaitez envoyer le lien au client pour commencer l\'appel vidéo',
      'modals.leadin_live.select_channel_to_invite_two': 'Veuillez noter que le lien expirera au bout d\'une heure',
      'modals.leadin_live.send_invitation': 'Envoyer une invitation',
      'modals.leadin_live.send_link_to_invite': 'Envoyer le lien pour commencer l\'appel vidéo',
      'modals.leadin_live.subheader': 'Un pas de plus dans la gestion des leads',
      'modals.new.lead.title': 'Nouveau lead',
      'modals.new_to_ontrack.title': 'Passer lead à “suivi”',
      'modals.next.button': 'Suivant',
      'modals.next_steps': 'Prochaine Étape',
      'modals.on_track.comments.required': 'Commentaire obligatoire',
      'modals.on_track.on_track_status.required': 'Selectioner une option',
      'modals.on_track.title': 'Interaction',
      'modals.reminder.this_lead_already_has_a_reminder': 'Ce lead a déjà un rappel',
      'modals.reminder.title': 'Rappel',
      'modals.retry_import.button': 'Charger le fichier à nouveau',
      'modals.revert.close.cancel': 'Annuler la vente',
      'modals.revert.close_sale.title': 'Renverser la vente finalisé',
      'modals.save.button': 'Garder',
      'modals.select_user_to_assign_lead': 'Sélectionner un utilisateur pour lui assigner des leads',
      'modals.select_user_to_transfer_lead': 'Sélectionner un utilisateur pour lui transférer des leads',
      'modals.send.button': 'Envoyer',
      'modals.send_mail.body.required': 'Corps du message obligatoire',
      'modals.send_mail.subject': 'Sujet',
      'modals.send_mail.subject.required': 'Sujet obligatoire',
      'modals.send_mail.title': 'Envoi d’un mail',
      'modals.send_mail.write_your_email': 'Composez un mail',
      'modals.send_whats_app.comments.required': 'Commentaire obligatoire',
      'modals.send_whatsapp.title': 'Envoyer WhatsApp',
      'modals.send_whatsapp.write_your_whatsapp': 'Composez votre message',
      'modals.title.postal_code': 'Code Postal',
      'modals.title.address': 'Adresse',
      'modals.transfer.button': 'Transférer',
      'modals.transfer_leads_title': 'Transférer des leads',
      'modals.add_postal_code.button': 'Ajouter un code postal',
      'modals.add_origin.button': 'Ajouter une origine',
      'modals.configure_rules.button': 'Je veux lui configurer la règle',
      'modals.new.rule.button': 'Nouvelle Règle',
      'modals.finish': 'Finir',
      'modals.previous.button': 'Précédent',
      'modals.see_everything.button': 'Quiero que lo vea todo',
      'modals.selected.origins': 'Origines sélectionnées',
      'modals.selected.postal_codes': 'Codes postaux sélectionnés',
      'page.mylead.no_especificado': 'Pas spécifié',
      'pages.configuration.concurrences': 'Coïncidence',
      'pages.dashboard-bdc.assigned': 'Leads assignés',
      'pages.dashboard-bdc.expired_on_track_leads': 'Leads expiré',
      'pages.dashboard-bdc.no_track_leads': 'Leads suivis',
      'pages.dashboard-bdc.on_track_leads': 'Leads suivis',
      'pages.dashboard-bdc.unnasignedLeads': 'Leads pas assignés',
      'pages.dropdown-with-rules.title': 'Listes déroulantes par règles',
      'pages.historic.at': 'à',
      'pages.historic.duration_interaction': 'Durée de l’interaction',
      'pages.historic.for_the_day': 'pour le jour',
      'pages.historic.hidden_mail': 'Cacher adresse e-mail',
      'pages.historic.hidden_whatsapp': 'Cacher WhatsApp',
      'pages.historic.inboud_leads': 'Entrée de leads',
      'pages.historic.lead_assigned_to': 'Leads assigné à',
      'pages.historic.lead_sold_on': 'Lead vendu le:',
      'pages.historic.lead_transfered_to': 'Lead transfer à',
      'pages.historic.not_contacted': 'Pas contacté',
      'pages.historic.scheduled_appointment': 'Rendez-vous planifié',
      'pages.historic.show_mail': 'Voir dresse e-mail',
      'pages.historic.show_whatsapp': 'Voir WhatsApp',
      'pages.historic.status_label': 'Lead étiqueté',
      'pages.historic.visit_attended': 'Visite réalisé avec succès',
      'pages.historic.visit_not_attended': 'Visite pas réalisée',
      'pages.leadin_live.subtitle': 'Attendez, s’il-vous-plait',
      'pages.leadin_live.title': 'Rediriger à DMSVO Live',
      'pages.leads.actions': 'Actions',
      'pages.leads.address': 'Adresse',
      'pages.leads.apply': 'Appliquer',
      'pages.leads.appointment': 'Rendez-vous',
      'pages.leads.appointments': 'Rendez-vous',
      'pages.leads.archive': 'Classer',
      'pages.leads.assign': 'Assigner',
      'pages.leads.assigned': 'Assigné',
      'pages.leads.assigned_to': 'Assigné à',
      'pages.leads.bemycar_update': 'Intégré avec Bemycar',
      'pages.leads.brand': 'Marque',
      'pages.leads.brands': 'Marques',
      'pages.leads.browse_files': 'Examiner les fichiers',
      'pages.leads.calendar': 'Calendrier',
      'pages.leads.channel': 'Canal',
      'pages.leads.channels': 'Canaux',
      'pages.leads.comments': 'Commentaire',
      'pages.leads.contacteds': 'Contactés',
      'pages.leads.created_at': 'Entrée',
      'pages.leads.created_at_special': 'entrée',
      'pages.leads.custom_filter.advise': 'Il y a un filtre personnalisé active. Veuillez le supprimer pour pouvoir utiliser ce filtre',
      'pages.leads.date_of': 'Date de',
      'pages.leads.date_of_special': 'Date d`',
      'pages.leads.day': 'jour',
      'pages.leads.days': 'jours',
      'pages.leads.dealer': 'Concession',
      'pages.leads.dealers': 'Concessions',
      'pages.leads.delete': 'Supprimer',
      'pages.leads.description': 'Description',
      'pages.leads.description_model': 'Intérêt',
      'pages.leads.drop_file_here': 'Mettez le fichier ici',
      'pages.leads.email': 'Adresse e-mail',
      'pages.leads.vat': 'NIF/SIRET',
      'pages.leads.from': 'Dès',
      'pages.leads.has_comment': 'Avec commentaire',
      'pages.leads.has_email': 'Avec e-mail',
      'pages.leads.has_phone': 'Avec téléphone',
      'pages.leads.hour': 'Aujourd’hui',
      'pages.leads.hours': 'heures',
      'pages.leads.import.error.headers': 'Les intitulés du fichier csv ne sont pas corrects',
      'pages.leads.import.error.type_not_found': 'Le type indiqué n’est pas valide. Valeurs supportées : V.N. / V.O. / Après-vente / Vide’',
      'pages.leads.lead': 'Lead',
      'pages.leads.leads': 'Leads',
      'pages.leads.leads_per_page': 'Leads pour page',
      'pages.leads.location': 'Ville',
      'pages.leads.model': 'Modèle',
      'pages.leads.scoring': 'Scoring',
      'pages.leads.tag': 'Tags',
      'pages.leads.month': 'Mois',
      'pages.leads.months': 'Mois',
      'pages.leads.motive_of_cancelation': 'Ecrivez la raison de l’annulation ici',
      'pages.leads.name': 'Nom',
      'pages.leads.new': 'Nouveau',
      'pages.leads.news': 'Nouveaux',
      'pages.leads.open': 'Ouverts',
      'pages.leads.origin': 'Origine',
      'pages.leads.others_f': 'Autres',
      'pages.leads.pending': 'Expiré',
      'pages.leads.phone': 'Téléphone',
      'pages.leads.postal_code': 'Code postal',
      'pages.leads.province_and_location': 'Région / Ville',
      'pages.leads.put_your_comment': 'Laissez un commentaire ici',
      'pages.leads.reminder': 'Rappel',
      'pages.leads.reminders': 'Rappels',
      'pages.leads.reopen': 'Réouvrir',
      'pages.leads.reset_filter': 'Supprimer les filtres',
      'pages.leads.search': 'Chercher',
      'pages.leads.select_all': 'Sélectionner tout',
      'pages.leads.select_element': 'Sélectionner un élément',
      'pages.leads.select_element.error': 'Sélectionnez au moins un élément',
      'pages.leads.select_option': 'Sélectionner une option',
      'pages.leads.status': 'État',
      'pages.leads.status.archived': 'Classé',
      'pages.leads.status.closed': 'Vente finalisée',
      'pages.leads.status.cold': 'Froid',
      'pages.leads.status.hot': 'Chaud',
      'pages.leads.status.new': 'Nouveau lead',
      'pages.leads.status.new_message': 'Nouveau message',
      'pages.leads.status.on_track': 'Suivi',
      'pages.leads.status.warm': 'Tiède',
      'pages.leads.status.type.prequalification': 'Pré-qualification',
      'pages.leads.status.type.buyed': 'Déjà acheté',
      'pages.leads.status.type.notbuyed': 'Pas d\'achat',
      'pages.leads.tags.24h': '24h',
      'pages.leads.tags.48h': '48h',
      'pages.leads.tags.defeated': 'Expiré',
      'pages.leads.tags.expiration': 'Expiration du délai',
      'pages.leads.tags.new': 'Nouveau',
      'pages.leads.tags.today': 'Aujourd’hui',
      'pages.leads.tags.prequalification': 'Pré-qualification',
      'pages.leads.to': 'À',
      'pages.leads.today': 'Aujourd’hui',
      'pages.leads.tomorrow': 'Demain',
      'pages.leads.transfer': 'Transférer',
      'pages.leads.transfereds': 'Transférés',
      'pages.leads.type': 'Type',
      'pages.leads.type.': 'Non spécifié',
      'pages.leads.type.after_sale': 'Après-vente',
      'pages.leads.type.commercial': 'Véhicules commerciaux',
      'pages.leads.type.fleet': 'Flottes',
      'pages.leads.type.new_vehicle': 'V.N.',
      'pages.leads.type.rent_a_car': 'Rent a Car',
      'pages.leads.type.renting': 'Renting',
      'pages.leads.type.unknow': 'Non spécifié',
      'pages.leads.type.used_vehicle': 'V.O.',
      'pages.leads.unselect_all': 'Supprimer la sélection',
      'pages.leads.updated_at': 'Modification',
      'pages.leads.user': 'Utilisateur',
      'pages.leads.users': 'Utilisateurs',
      'pages.leads.visit': 'Rendez-vous',
      'pages.leads.yesterday': 'Hier',
      'pages.marketing.contacted': 'Contactés',
      'pages.marketing.conversion_indicators': 'Indicateur de conversion',
      'pages.marketing.inboud_leads_per_channels': 'Entrée de leads par canal/heure',
      'pages.marketing.inboud_leads_per_channels_day_week': 'Entrée de leads par canal/jour',
      'pages.marketing.leads': 'Leads',
      'pages.marketing.on_track': 'Suivi',
      'pages.marketing.sales': 'Ventes',
      'pages.marketing.totalAppointments': 'Rendez-vous',
      'pages.marketing.visited': 'Visites',
      'pages.metrics.sales.archived.leads': 'Classés',
      'pages.metrics.sales.closed.leads': 'Ventes',
      'pages.metrics.sales.contacted.leads': 'Contactés',
      'pages.metrics.sales.interactions.count': 'Nº interactions',
      'pages.metrics.sales.interactions.total': 'TOTAL',
      'pages.metrics.sales.leads': 'Leads',
      'pages.metrics.sales.min.leads': 'Min/Lead',
      'pages.metrics.sales.onTrack.leads': 'Suivis',
      'pages.metrics.sales.salesman': 'Vendeur',
      'pages.metrics.sales.salesman.unnasigned': 'Pas assignés',
      'pages.metrics.sales.salesmen': 'Vendeurs',
      'pages.metrics.sales.totalAppointments': 'Rendez-vous',
      'pages.metrics.sales.visited.leads': 'Visites',
      'pages.mylead.add_comment': 'Ajouter un commentaire',
      'pages.mylead.add_event': 'Ajouter événement',
      'pages.mylead.appointment_remove': 'Rendez-vous supprimé',
      'pages.mylead.details.after_sale': 'Après-vente',
      'pages.mylead.details.commercial': 'Véhicule commercial',
      'pages.mylead.details.createdat': 'Succès',
      'pages.mylead.details.fleet': 'Flottes',
      'pages.mylead.details.new_vehicle': 'Véhicule nouveau',
      'pages.mylead.details.renting': 'Renting',
      'pages.mylead.details.unknow': 'Pas spécifié',
      'pages.mylead.details.unnasigned': 'Pas assigné',
      'pages.mylead.details.used_vehicle': 'Véhicule d’occasion',
      'pages.mylead.exclusive.lead': 'Lead attribué à:',
      'pages.mylead.remove': 'supprimé',
      'pages.mylead.tab.concurrences': 'Coïncidences',
      'pages.mylead.tab.quotations': 'Devis',
      'pages.mylead.tab.crm': 'Partager',
      'pages.mylead.tab.crm.apply': 'Envoyer lead',
      'pages.mylead.tab.crm.external_integration': 'Sélectionner un système externe',
      'pages.mylead.tab.crm.external_integration_name': 'Destin',
      'pages.mylead.tab.crm.new_external_systems': 'Vous pouvez aussi demander des nouvelles intégrations',
      'pages.mylead.tab.crm.no_external_systems': 'Il n’y a pas aucun système externe configure; actuellement les intégrations disponibles pour configurer sont:',
      'pages.mylead.tab.crm.no_external_systems_help': 'Si vous avez besoin de configurer un système externe, veuillez nous contacter',
      'pages.mylead.tab.crm.shipping': 'Envoie',
      'pages.mylead.tab.crm.user': 'Utilisateur',
      'pages.mylead.tab.events': 'Événements',
      'pages.mylead.tab.historic': 'Histoire',
      'pages.mylead.tab.interaction': 'Appel en cours',
      'pages.mylead.tab.lead': 'Lead',
      'pages.mylead.tab.metric': 'Détail',
      'pages.mylead.tab.schedule': 'Événements',
      'pages.notice.url.show_more': 'Plus d\'informations',
      'pages.profile.activate_business_hours': 'Activer l’horaire de travail',
      'pages.profile.activate_lead_table_visibility': 'Cacher des informations de la liste des leads',
      'pages.profile.activate_lead_table_visibility_visible': 'Visible',
      'pages.profile.activate_lead_table_visibility_no_visible': 'Caché',
      'pages.profile.email': 'Adresse e-mail',
      'pages.profile.language': 'Langue',
      'pages.profile.language.en': 'Anglais',
      'pages.profile.language.es': 'Espagnol',
      'pages.profile.language.fr': 'Français',
      'pages.profile.language.pt': 'Portugais',
      'pages.profile.lastname': 'Nom',
      'pages.profile.name': 'Prénom',
      'pages.profile.phone_number': 'Téléphone',
      'pages.profile.notification': 'Notifications',
      'pages.profile.notification.placeholder': 'Marquez les notifications des leads',
      'pages.profile.timezone': 'Fuseau horaire',
      'pages.profile.workingday.0': 'Dimanche',
      'pages.profile.workingday.1': 'Lundi',
      'pages.profile.workingday.2': 'Mardi',
      'pages.profile.workingday.3': 'Mercredi',
      'pages.profile.workingday.4': 'Jeudi',
      'pages.profile.workingday.5': 'Vendredi',
      'pages.profile.workingday.6': 'Samedi',
      'pages.profile.workingday.short.0': 'D',
      'pages.profile.workingday.short.1': 'L',
      'pages.profile.workingday.short.2': 'M',
      'pages.profile.workingday.short.3': 'M',
      'pages.profile.workingday.short.4': 'J',
      'pages.profile.workingday.short.5': 'V',
      'pages.profile.workingday.short.6': 'S',
      'pages.profile.sending_email': 'E-mail d\'envoie',
      'pages.profile.user_account': 'Compte d\'utilisateur',
      'pages.profile.rules.positive_rules': 'Règles Positives',
      'pages.profile.rules.active': 'Active',
      'pages.profile.positive_rules': 'Règle positive',
      'pages.reporting.bdc.bdctimes': 'Rapport des leads gérés par des utilisateur avec rôle de BDC',
      'pages.reporting.download': 'Télécharger',
      'pages.reporting.tabtitle.bdc': 'BDC',
      'pages.reporting.tabtitle.leads': 'Leads',
      'pages.reporting.tabtitle.marketing': 'Marketing',
      'pages.reporting.tabtitle.sales': 'Ventes',
      'pages.sales.sales_funnel': 'Entonnoir de ventes',
      'pages.sales.sales_funnel.archived': 'Classés',
      'pages.sales.sales_funnel.on_track': 'Suivi',
      'pages.sales.time_reports': 'Temps de réponse des leads',
      'pages.sales.time_reports_by_user': 'Temps de réponse des leads par utilisateur',
      'pages.schedule.events_to_manage': 'Avant, vous avez d\'autres événements à gérer',
      'pages.schedule.no_future_events': 'Aucun événement futur',
      'pages.security.change_password.button_change_password': 'Changer le mot de passe',
      'pages.security.change_password.confirm_password_placeholder': 'Confirmation',
      'pages.security.change_password.confirm_password_validation_required': 'Confirmation du mot de passe obligatoire',
      'pages.security.change_password.modals.error.body': 'Veuillez vérifier votre accès',
      'pages.security.change_password.modals.error.title': 'Erreur de changement du mot de passe',
      'pages.security.change_password.modals.success.body': 'Veuillez entrer avec le nouveau mot de passe',
      'pages.security.change_password.modals.success.title': 'Changement de mot de passe avec succès',
      'pages.security.change_password.password_placeholder': 'Nouveau mot de passe',
      'pages.security.change_password.password_validation_capital_case': 'Il doit avoir au moins une majuscule',
      'pages.security.change_password.password_validation_max_length': 'Il doit avoir moins de %number% caractères',
      'pages.security.change_password.password_validation_min_length': 'Il doit avoir plus de %number% caractères',
      'pages.security.change_password.password_validation_number': 'Il doit avoir au moins un chiffre',
      'pages.security.change_password.password_validation_required': 'Nouveau mot de passe obligatoire',
      'pages.security.change_password.password_validation_special_char': 'Il doit avoir au moins un caractère spécial',
      'pages.security.change_password.passwords_must_be_equals': 'Les mots de passe doivent être identiques',
      'pages.security.change_password.title': 'Changer le mot de passe',
      'pages.security.change_password.title_change_password': 'Changement du mot de passe',
      'pages.security.login.button_sign_in': 'Entrer',
      'pages.security.login.forgot_password': 'Mot de passe oublié?',
      'pages.security.login.input_email_placeholder': 'Adresse e-mail',
      'pages.security.login.input_email_validation_required': 'Veuillez remplir l’adresse e-mail',
      'pages.security.login.input_password_placeholder': 'Mot de passe',
      'pages.security.login.input_password_validation_required': 'Veuillez remplir le mot de passe',
      'pages.security.login.modals.error.body': 'Veuillez vérifier votre accès',
      'pages.security.login.modals.error.title': 'Erreur d’accès',
      'pages.security.login.modals.invalid.body': 'Veuillez vérifier votre accès',
      'pages.security.login.modals.invalid.title': 'Accès mauvais',
      'pages.security.login.title': 'Se connecter',
      'pages.security.reset_password.modals.error.body': 'Il y a eu un erreur de relancement du mot de passe',
      'pages.security.reset_password.modals.error.title': 'Erreur',
      'pages.security.reset_password.modals.success.body': 'Veuillez entrer avec votre nouveau mot de passe',
      'pages.security.reset_password.modals.success.title': 'Mot de passe relancé avec succès',
      'pages.security.reset_password_email.already_have_account': 'Avez-vous déjà un compte?',
      'pages.security.reset_password_email.button_reset_password': 'Relancer le mot de passe',
      'pages.security.reset_password_email.email_placeholder': 'Adresse e-mail',
      'pages.security.reset_password_email.email_required': 'Adresse e-mail obligatoire',
      'pages.security.reset_password_email.modals.error.body': 'Il y a eu un erreur d’envoi du mail de récupération',
      'pages.security.reset_password_email.modals.error.title': 'Erreur',
      'pages.security.reset_password_email.modals.success.body': 'Vous recevrez un mail pour récupérer votre mot de passe',
      'pages.security.reset_password_email.modals.success.title': 'Mail de relancement du mot de passe envoyé',
      'pages.security.reset_password_email.sign_in': 'S’identifier',
      'pages.security.reset_password_email.title': 'Relancer le mot de passe',
      'pages.tracking.email.title': 'Suivi des e-mail ',
      'pages.leads.no_potencial_sellers': 'Leads NON accessibles par les conseillers',
      'pages.leads.potencial_sellers': 'Utilisateurs qui peuvent gérer le lead',
      'pages.leads.accessible_lead': 'Leads accessibles par:',
      'pages.leads.quotation.loading': 'Chargement',
      'pages.leads.quotation.vehicle': 'Véhicule',
      'pages.leads.quotation.amount': 'Montant',
      'pages.leads.quotation.status': 'État',
      'pages.leads.quotation.creationDate': 'Création',
      'pages.leads.quotation.dates': 'Dates',
      'pages.leads.quotation.modificationDate': 'Dernière modification',
      'pages.leads.quotation.quotationCreation': 'Créer un devis',
      'pages.leads.quotation.quotationModification': 'Modifier le devis',
      'pages.leads.quotation.contractDate': 'Date du contrat',
      'pages.leads.quotation.saleDate': 'Date de vente',      
      'pages.leads.quotation.quotationSoldClosingComment': 'Lead fermé pour vente',
      'pages.create.assignment-rule.title': 'Assistant de création de règles',
      'pages.create.assignment-rule.step_1': 'Étape 1',
      'pages.create.assignment-rule.step_2': 'Étape 2',
      'pages.create.assignment-rule.step_3': 'Étape 3',
      'pages.create.assignment-rule.step_4': 'Étape 4',
      'pages.create.assignment-rule.step_5': 'Étape 5',
      'pages.create.assignment-rule.step_6': 'Étape 6',
      'pages.create.assignment-rule.step_7': 'Étape 7',
      'pages.create.assignment-rule.step_8': 'Étape 8',
      'pages.create.assignment-rule.step_1.description': 'Nom et utilisateur',
      'pages.create.assignment-rule.step_1.description_1': 'Nom de la règle',
      'pages.create.assignment-rule.step_1.description_2': 'Utilisateur',
      'pages.create.assignment-rule.step_1.description_3': 'À quoi cet utilisateur aura-t-il accès?',
      'pages.create.assignment-rule.step_2.description': 'Types de leads',
      'pages.create.assignment-rule.step_3.description': 'Concessions',
      'pages.create.assignment-rule.step_4.description': 'Canaux',
      'pages.create.assignment-rule.step_5.description': 'Marques',
      'pages.create.assignment-rule.step_6.description': 'Codes postaux',
      'pages.create.assignment-rule.step_7.description': 'Origines',
      'pages.create.assignment-rule.step_8.description': 'Types de règles',
      'pages.create.assignment-rule.users_unselected': 'Utilisateurs sans sélectionner',
      'pages.create.assignment-rule.users_selected': 'Utilisateurs sélectionnés',
      'pages.rules.leads_per_page': 'Règles par page',
      'planning.comment': 'Commentaire',
      'planning.company': 'Entreprisse',
      'planning.date': 'Date',
      'planning.getting_events': 'Récupération des événements',
      'planning.lead': 'Lead',
      'planning.no_events': 'Aucun événement.',
      'planning.user': 'Utilisateur',
      'pwa.update_service.body': 'DMSVO sera mis au jour automatiquement',
      'pwa.update_service.title': 'Nouvelle version disponible',
      'response.no': 'Non',
      'response.yes': 'Oui',
      'response.is_active': 'Actif',
      'response.is_not_active': 'Désactivée',
      'response.is_positive': 'Règle positive',
      'response.is_negative': 'Règle négative',
      'shared.brands': 'Marques',
      'shared.channels': 'Canaux',
      'shared.companies': 'Enterprises',
      'shared.create_new_origin': 'Créer une origine',
      'shared.dealers': 'Concessions',
      'shared.from': 'De',
      'shared.label_not_found': 'Aucun résultat trouvé',
      'shared.search': 'Chercher',
      'shared.select_all': 'Sélectionner tout',
      'shared.select_element': 'Sélectionnez un élément',
      'shared.to': 'Pour',
      'shared.types': 'Types',
      'shared.types_of_leads': 'Types de Lead',
      'shared.unselect_all': 'Supprimer la sélection',
      'shared.users': 'Utilisateurs',
      'shared.modules': 'Modules',
      'shared.load_more': 'Charger plus',
      'table.no_data_display': 'Pas de données à montrer',
      'template.import.header.brand': 'Marque',
      'template.import.header.channel': 'Canal',
      'template.import.header.comment': 'Commentaire',
      'template.import.header.dealer': 'Concession',
      'template.import.header.description_model': 'Modèle',
      'template.import.header.email': 'Adresse e-mail',
      'template.import.header.vat': 'NIF/SIRET',
      'template.import.header.name_and_lastname': 'Nom et prénom',
      'template.import.header.origin': 'Origine',
      'template.import.header.phone': 'Téléphone',
      'template.import.header.postal_code': 'Code postal',
      'template.import.header.type': 'Type',
      'template.import.name_file': 'Document témoin',
      'time.abrv_hours': 'h',
      'time.abrv_minutes': 'min',
      'time.abrv_seconds': 'seg',
      'time.report.chart.contacted.customers': 'Nº de clients contactés',
      'time.report.chart.range.time.minutes': 'Rang de temps (minutes)',
      'time.report.chart.serie.bussiness_contacted_leads': 'Temps commercial',
      'time.report.chart.serie.contacted_leads': 'Temps réel',
      'timezone.Atlantic/Canary': 'Atlantique',
      'timezone.Europe/Lisbon': 'Europe/Lisbonne',
      'timezone.Europe/Madrid': 'Europe/Paris',
      'toast.title.appointment_date_success': 'Rendez-vous de lead',
      'toast.title.lead_archived_success': 'Leads classés',
      'toast.title.lead_close_error': 'Erreur de fermeture de lead',
      'toast.title.lead_revert_close_error': 'Erreur d’annulation de la vente',
      'toaster.add_comment.error.title': 'Erreur lors de l’ajout de commentaire',
      'toaster.add_comment.success.body': 'Le commentaire a été ajouté correctement',
      'toaster.add_comment.success.title': 'Commentaire ajouté',
      'toaster.body.delivery_method_changed': 'La méthode de notification a été modifiée avec succès',
      'toaster.body.last_name_changed': 'Le nom de l’utilisateur a été modifié avec succès',
      'toaster.body.name_changed': 'Le prénom de l’utilisateur’ a été modifié avec succès',
      'toaster.body.phone_number_changed': 'Le téléphone e l’utilisateur a été modifié avec succès.',
      'toaster.body.sign_changed': 'La signature de l’utilisateur a été modifiée avec succès',
      'toaster.call.error': 'L’appel n’a pas été effectué',
      'toaster.call.error.body': 'L’appel n’a pas été effectué avec succès',
      'toaster.call.error.body.another.started.call': 'Un autre appel est en cours',
      'toaster.call.error.no_equal_lead_id': 'Problème de récupération des informations du lead. Veuillez réessayer',
      'toaster.call.success': 'Appel complété avec succès',
      'toaster.call.success.body': 'L’appel a été complété avec succès',
      'toaster.configuration_error': 'Erreur de configuration',
      'toaster.configuration_error.generic_fail': 'Erreur',
      'toaster.configuration_error.message': 'La journée de travail n\'a pas été enregistré avec succès',
      'toaster.edit.lead.error': 'Erreur de modification du lead',
      'toaster.edit.lead.error.body': 'Il y a eu un erreur inespéré de modification du lead',
      'toaster.edit.lead.success': 'Lead modifié avec succès',
      'toaster.edit.lead.success.body': 'Le lead sélectionné a été modifié correctement',
      'toaster.email.error': 'Erreur d’envoi de e-mail',
      'toaster.email_sent': 'Email envoyé',
      'toaster.email_sent.message': 'Email envoyé avec succès à',
      'toaster.error.body.delivery_method_changed': 'Il y a eu un erreur de modification de la méthode de notification de l’utilisateur',
      'toaster.error.body.last_name_changed': 'Il y a eu un erreur de modification du nom de l’utilisateur',
      'toaster.error.body.name_changed': 'Il y a eu un erreur de modification du profil',
      'toaster.error.body.phone_number_changed': 'Il y a eu un erreur de modification du téléphone',
      'toaster.error.body.phone_number_invalid': 'Ce numéro de téléphone n\'est pas valide',
      'toaster.error.body.sign_changed': 'Il y a eu un erreur de modification de la signature de l’utilisateur',
      'toaster.error.title.profile': 'Erreur de modification du profil',
      'toaster.error.title.sign_changed': 'Erreur de modification de la signature',
      'toaster.integration.error': 'Intégration pas réussie',
      'toaster.integration.success': 'Intégration réalisée avec succès',
      'toaster.integration.success_body': 'Le Lead a été intégré dans le système avec succès',
      'toaster.lead.assigned.error': 'Erreur d’assignation du lead',
      'toaster.lead.assigned.error.body': 'Il y a eu un erreur inespéré d’assignation du lead',
      'toaster.lead.assigned_success': 'Lead assigné avec succès',
      'toaster.lead.assigned_sucess_body': 'Les leads marqués ont été assignés avec succès',
      'toaster.lead.deleted.error': 'Erreur de suppression du lead',
      'toaster.lead.deleted.error.body': 'Il y a eu un erreur inespéré de suppression du lead',
      'toaster.lead.deleted.success': 'Lead supprimé avec succès',
      'toaster.lead.deleted.success.body': 'Les leads sélectionnés ont été supprimés avec succès',
      'toaster.lead.get.error': 'Erreur de récupération du lead',
      'toaster.lead.on_track': 'Lead suivi',
      'toaster.lead.status_on_track_changed': 'L’état de lead suivi a été actualisé',
      'toaster.lead.transfered.error': 'Erreur de transfert du lead',
      'toaster.lead.transfered.error.body': 'Il y a eu un erreur inespéré de transfert de lead',
      'toaster.lead_reminder_success': 'Rappel ajouté au lead avec succès',
      'toaster.lead_remove_event_success': 'Événement éliminé avec succès',
      'toaster.lead_status.closed': 'Vente finalisée',
      'toaster.lead_transfered_success': 'Lead transféré avec succès',
      'toaster.lead_transfered_success_body': 'Les leads marqués ont été transférés avec succès',
      'toaster.new.lead.error': 'Erreur de création du lead',
      'toaster.new.rule.error': 'Erreur de création de règles',
      'toaster.new.lead.error.body': 'Il y a eu un erreur inespéré de création du lead',
      'toaster.new.rule.unhandled_error': 'Les règles n\'ont pas pu être créées en raison d\'une erreur',
      'toaster.new.repeated_rule.error.title': 'Il y a des règles répétées',
      'toaster.new.repeated_rule.error.body': 'Impossible de créer les règles REPLACE_THIS, car elles sont répétées',
      'toaster.new.lead.success': 'Lead crée avec succès',
      'toaster.new.lead.success.body': 'Le lead a été créé avec succès',
      'toaster.new.rules.title': 'Création des règles d\'attribution',
      'toaster.new.rules.success.body': 'Les règles REPLACE_THIS ont été créées avec succès',
      'toaster.saved_configuration': 'Configuration enregistrée',
      'toaster.saved_configuration.message': 'La configuration de l\'entreprise sélectionnée a été enregistrée avec succès',
      'toaster.saved_hours': 'Journée de travail enregistré',
      'toaster.saved_hours.update_message': 'La configuration de la journée de travail a été enregistré avec succès',
      'toaster.lead_table_visibility': 'Affichage du tableau des leads actualisé ',
      'toaster.lead_table_visibility.update_message': 'La configuration du tableau des leads a été mise à jour avec succès.',
      'toaster.title.lead_reminder_success': 'Rappel ajouté',
      'toaster.title.lead_remove_event_success': 'Evénement éliminé',
      'toaster.title.profile': 'Profil actualisé avec succès',
      'toaster.title.sign_changed': 'Signature modifiée avec succès',
      'toaster.visit_confirmation.success': 'Rapport de visite terminé avec succès',
      'toaster.visit_confirmation.sucess.body': 'Le rapport de visite a été terminé avec succès',
      'toaster.whatsapp.error': 'Erreur d’envoi du WhatsApp',
      'toaster.whatsapp.succes.title': 'WhatsApp envoyé',
      'toaster.whatsapp.success_body': 'Message WhatsApp envoyé avec succès',
      'toaster.quotations.load.error': 'Erreur lors du chargement des devis',
      'toasts.messages.appointment_date_success': 'Rendez-vous de lead programmé avec succés',
      'toasts.messages.lead_archived_success': 'Lead classé avec succès',
      'toasts.messages.lead_close_success': 'Le lead a été finalisé avec succès',
      'toasts.create_rules.too_many_rows.title': 'Limite de création de règles atteinte',
      'toasts.create_rules.too_many_rows.body': 'Une tentative de création de règles REPLACE_THIS a été effectuée, mais la limite est de 300.',
      'tracking.email.true': 'Activé',
      'tracking.email.false': 'Désactivée',
      'user.email': 'E-mail',
      'user.password': 'Mot de passe',
      'user.profile': 'Profil',
      'user.rules': 'Règles d’assignation',
      'user.save_signature': 'Garder la signature',
      'user.schedule': 'Horaire',
      'user.role.legend': 'Rôle d\'utilisateur',
      'user.role.role_superadmin': 'Super Administrateur',
      'user.role.role_user': 'Vendeur',
      'user.role.role_admin': 'Administrateur',
      'user.role.role_bdc': 'BDC',
      'user.role.role_dapda': 'Dapda',
      'modals.simulate.lead.button': 'Simuler',
      'modals.simulate.lead.title': 'Simulation d’un lead',
      'modals.simulate.lead.model': 'Modèle d’essai',
      'modals.simulate.lead.phone': '910000000',
      'modals.simulate.lead.email': 'test@test.test',
      'modals.confirm.title': 'Êtes-vous sûr?',
      'modals.confirm.message': 'Rappelez-vous que cette action ne peut pas être inversée',
      'assignment.rules.table.row.button.activate': 'Activée',
      'assignment.rules.table.row.button.desactivate': 'Désactivée',
      'toaster.saved_assignmentrule': 'Règle enregistrée',
      'toaster.saved_assignmentrule.message': ' La règle de répartition de leads a été correctement enregistré',
      'toaster.deleted_assignmentrule': 'Règle effacée',
      'toaster.deleted_assignmentrule.message': 'La règle de répartition de leads a été correctement effacée',
      'modals.assignmentrule.edit.title': 'Modifier la règle de répartition',
      'modals.assignmentrule.edit.negative_rule': 'Règle négative',
      'modals.assignmentrule.edit.user': 'Utilisateur',
      'modals.assignmentrule.edit.name': 'Nom',
      'toaster.lead.assignmentrule.success': 'Modification réussie',
      'toaster.lead.assignmentrule.success.body': 'La règle sélectionnée a été modifiée avec succès',
      'toaster.lead.assignmentrule.error': 'Il y a eu une erreur',
      'toaster.lead.assignmentrule.error.body': 'Il y a eu une erreur lors de la modification de la règle de répartition sélectionnée',
      'toaster.lead.assignmentrule.repeat': 'Règle répétée',
      'toaster.lead.assignmentrule.repeat.body': 'Il existe déjà une règle de répartition avec les mêmes paramètres',
      'leadType.appraisal': 'leadType.appraisal',
      'leadType.spare_parts': 'leadType.spare_parts',
      'chart.lead_type.appraisal': 'chart.lead_type.appraisal',
      'chart.lead_type.spare_parts': 'chart.lead_type.spare_parts',
      'pages.leads.type.appraisal': 'pages.leads.type.appraisal',
      'pages.leads.type.spare_parts': 'pages.leads.type.spare_parts',
      'pages.mylead.details.appraisal': 'pages.mylead.details.appraisal',
      'pages.mylead.details.spare_parts': 'pages.mylead.details.spare_parts',
      'leadType.km0': 'leadType.km0',
      'chart.lead_type.km0': 'chart.lead_type.km0',
      'pages.leads.type.km0': 'pages.leads.type.km0',
      'pages.mylead.details.km0': 'pages.mylead.details.km0',
      'error.fail_comunications_with_woice': 'error.fail_comunications_with_woice',
      'error.woice_token_not_received': 'error.woice_token_not_received',
    };
}
